import { generateMedia } from 'styled-media-query';
import { maxViewPortMobile, maxViewPortSmallMobile, maxViewPortTablet } from './units';
export const screenSizes = {
    desktop: maxViewPortTablet,
    tablet: maxViewPortMobile,
    mobile: maxViewPortSmallMobile,
    smallMobile: 0,
};
export const threshold = generateMedia(Object.keys(screenSizes).reduce((acc, cur) => {
    acc[cur] = `${screenSizes[cur] + 1}px`;
    return acc;
}, {}));
// eslint-disable-next-line
export var EScreenSize;
(function (EScreenSize) {
    EScreenSize["descktop"] = "desktop";
    EScreenSize["tablet"] = "tablet";
    EScreenSize["mobile"] = "mobile";
    EScreenSize["smallMobile"] = "smallMobile";
})(EScreenSize || (EScreenSize = {}));
const join = (query) => Array.from(query).join('');
export const desktop = (style) => join(threshold.greaterThan(EScreenSize.descktop) `${style}`);
export const tablet = (style) => join(threshold.between(EScreenSize.tablet, EScreenSize.descktop) `${style}`);
export const mobile = (style) => join(threshold.between(EScreenSize.mobile, EScreenSize.tablet) `${style}`);
export const smallMobile = (style) => join(threshold.lessThan(EScreenSize.mobile) `${style}`);
export const mediaQueries = (prop, val) => [
    smallMobile(`${prop}: ${val.smallMobile};`),
    mobile(`${prop}: ${val.mobile};`),
    tablet(`${prop}: ${val.tablet};`),
    desktop(`${prop}: ${val.desktop};`)
]
    .join('\n');
